import { SVG } from "../../shared/svg";

export class VizSVG {

  static plus(): SVGSVGElement {
    const svg = SVG.svg(24, 24, "plus");
    svg.appendChild(SVG.path("M7 12L17 12"));
    svg.appendChild(SVG.path("M12 7L12 17"));
    return svg;
  }

  static minus(): SVGSVGElement {
    const svg = SVG.svg(24, 24, "plus");
    svg.appendChild(SVG.path("M7 12L17 12"));
    return svg;
  }

  static arrow(): SVGSVGElement {
    const svg = SVG.svg(10, 10, "arrow");
    svg.appendChild(SVG.path("M 2 1 L 7 4.5 L 2 8"));
    return svg;
  }

  static date_icon(): SVGSVGElement {
    const svg = SVG.svg(12, 12, "element-icon");
    const r = document.createElementNS("http://www.w3.org/2000/svg", "rect");
    r.setAttribute("x", "0.5");
    r.setAttribute("y", "0.5");
    r.setAttribute("width", "11");
    r.setAttribute("height", "11");
    r.setAttribute("rx", "1");
    svg.appendChild(SVG.path("M5.80859 9H6.5459V5.47705H5.81104L4.90039 6.10938V6.77344L5.76465 6.17285H5.80859V9Z", "icon-fill"));
    svg.appendChild(SVG.path("M0.5 3L11.5 3"));
    svg.appendChild(r);
    return svg;
  }

  static number_icon(): SVGSVGElement {
    const svg = SVG.svg(12, 12, "element-icon");
    svg.appendChild(SVG.path("M5.84863 11.3687H7.1084L7.69434 8.47559H9.56201L9.79639 7.23779H7.93604L8.43408 4.81348H10.2432L10.4775 3.58301H8.69043L9.25439 0.799805H8.00195L7.43066 3.58301H5.21875L5.77539 0.799805H4.53027L3.95166 3.58301H2.18652L1.9375 4.81348H3.70264L3.21924 7.23779H1.5127L1.271 8.47559H2.96289L2.38428 11.3687H3.62939L4.21533 8.47559H6.43457L5.84863 11.3687ZM4.41309 7.29639L4.92578 4.76221H7.23291L6.71289 7.29639H4.41309Z", "icon-fill"));
    return svg;
  }

  static text_icon(): SVGSVGElement {
    const svg = SVG.svg(12, 12, "element-icon");
    svg.appendChild(SVG.path("M5.44434 10H6.60645L4.0625 2.9541H2.88574L0.341797 10H1.46484L2.11426 8.0957H4.7998L5.44434 10ZM3.41797 4.19922H3.50098L4.52148 7.2168H2.39258L3.41797 4.19922ZM9.12598 10.0879C9.82422 10.0879 10.4053 9.78516 10.7227 9.24805H10.8057V10H11.8164V6.37207C11.8164 5.25879 11.0645 4.59473 9.73145 4.59473C8.52539 4.59473 7.66602 5.17578 7.55859 6.06934H8.57422C8.69141 5.68359 9.09668 5.46387 9.68262 5.46387C10.4004 5.46387 10.7715 5.79102 10.7715 6.37207V6.83594L9.33105 6.92383C8.06641 7.00195 7.35352 7.55371 7.35352 8.50586C7.35352 9.47266 8.10059 10.0879 9.12598 10.0879ZM9.39453 9.24316C8.82324 9.24316 8.4082 8.95508 8.4082 8.46191C8.4082 7.97852 8.74023 7.71973 9.47266 7.6709L10.7715 7.58301V8.04199C10.7715 8.72559 10.1855 9.24316 9.39453 9.24316Z", "icon-fill"));
    return svg;
  }

  static display_icon(): SVGSVGElement {
    const svg = SVG.svg(12, 12, "element-icon");
    const r = document.createElementNS("http://www.w3.org/2000/svg", "rect");
    r.setAttribute("x", "0.5");
    r.setAttribute("y", "0.5");
    r.setAttribute("width", "11");
    r.setAttribute("height", "11");
    r.setAttribute("rx", "1.5");
    svg.appendChild(r);
    svg.appendChild(SVG.path("M4 3L8 3"));
    return svg;
  }

  static display_icon_large(): SVGSVGElement {
    const svg = SVG.svg(28, 28, "header-icon");
    const r = SVG.rect(4.25, 5.25, 19, 17);
    r.setAttribute("rx", "2.5");
    r.setAttribute("stroke-width", "1.5");
    svg.appendChild(r);
    const l = document.createElementNS("http://www.w3.org/2000/svg", "line");
    l.setAttribute("x1", "10.5");
    l.setAttribute("y1", "9.25");
    l.setAttribute("x2", "17.25");
    l.setAttribute("y2", "9.25");
    l.setAttribute("stroke-width", "1.5");
    l.setAttribute("stroke-linecap", "round");
    svg.appendChild(l);
    return svg;
  }

  static bottom_panel_icon(): SVGSVGElement {
    const svg = SVG.svg(24, 24, "panel-icon");
    const r = SVG.rect(4.25, 4.25, 15, 15);
    r.setAttribute("rx", "1.5");
    r.setAttribute("stroke-width", "1.5");
    svg.appendChild(r);
    const l = document.createElementNS("http://www.w3.org/2000/svg", "line");
    l.setAttribute("x1", "4");
    l.setAttribute("y1", "14.5");
    l.setAttribute("x2", "20");
    l.setAttribute("y2", "14.5");
    svg.appendChild(l);
    return svg;
  }

  static open_icon(): SVGSVGElement {
    const svg = SVG.svg(15, 15, "inline-icon");
    const p = SVG.path("M5 1H3C1.89543 1 1 1.89543 1 3V11C1 12.1046 1.89543 13 3 13H11C12.1046 13 13 12.1046 13 11V9H11.5V11C11.5 11.2761 11.2761 11.5 11 11.5H3C2.72386 11.5 2.5 11.2761 2.5 11V3C2.5 2.72386 2.72386 2.5 3 2.5H5V1Z");
    svg.appendChild(p);
    const p2 = SVG.path("M7.5 1L12.25 1C12.6642 1 13 1.33579 13 1.75L13 6.5C13 6.91421 12.6642 7.25 12.25 7.25C11.8358 7.25 11.5 6.91421 11.5 6.5V3.56066L6.78033 8.28033C6.48744 8.57322 6.01256 8.57322 5.71967 8.28033C5.42678 7.98744 5.42678 7.51256 5.71967 7.21967L10.4393 2.5H7.5C7.08579 2.5 6.75 2.16421 6.75 1.75C6.75 1.33579 7.08579 1 7.5 1Z");
    p2.setAttribute("fill-rule", "evenodd");
    p2.setAttribute("clip-rule", "evenodd");
    svg.appendChild(p2);
    return svg;
  }

  static table_icon(): SVGSVGElement {
    const svg = SVG.svg(12, 12, "element-icon");
    const r = document.createElementNS("http://www.w3.org/2000/svg", "rect");
    r.setAttribute("x", "0.5");
    r.setAttribute("y", "0.5");
    r.setAttribute("width", "11");
    r.setAttribute("height", "11");
    r.setAttribute("rx", "1");
    svg.appendChild(r);
    svg.appendChild(SVG.path("M2 2.5L10 2.5"));
    svg.appendChild(SVG.path("M2 5L4 5"));
    svg.appendChild(SVG.path("M5 5L10 5"));
    svg.appendChild(SVG.path("M2 7L4 7"));
    svg.appendChild(SVG.path("M5 7L10 7"));
    svg.appendChild(SVG.path("M2 9L4 9"));
    svg.appendChild(SVG.path("M5 9L10 9"));
    return svg;
  }

  static plus_icon(): SVGSVGElement {
    const svg = SVG.svg(12, 12, "element-icon");
    const p1 = document.createElementNS("http://www.w3.org/2000/svg", "path");
    p1.setAttribute("d", "M2 6L10 6");
    svg.appendChild(p1);
    const p2 = document.createElementNS("http://www.w3.org/2000/svg", "path");
    p2.setAttribute("d", "M6 2L6 10");
    svg.appendChild(p2);
    return svg;
  }

  static large_table_icon(): SVGSVGElement {
    const svg = SVG.svg(29, 36, "table-icon");
    const r = SVG.rect(0.5, 0.5, 28, 35);
    r.classList.add("table-bg");
    r.setAttribute("fill", "white");
    svg.appendChild(r);
    const r2 = SVG.rect(4, 4, 21, 3);
    r2.setAttribute("fill", "#DADADA");
    svg.appendChild(r2);

    let top = 25;
    for (let i = 0; i < 3; i++) {
      const r3 = SVG.rect(4, top, 6, 1);
      r3.setAttribute("fill", "#DADADA");
      const r4 = SVG.rect(12, top, 13, 1);
      r4.setAttribute("fill", "#DADADA");
      svg.appendChild(r3);
      svg.appendChild(r4);
      top += 3;
    }
    return svg;
  }

  static visibility_icon(): SVGSVGElement {
    const svg = SVG.svg(13, 10);
    const p1 = document.createElementNS("http://www.w3.org/2000/svg", "path");
    p1.setAttribute("fill-rule", "evenodd");
    p1.setAttribute("clip-rule", "evenodd");
    p1.setAttribute("d", "M6.5 10C11 10 13 5 13 5C13 5 11 0 6.5 0C2 0 0 5 0 5C0 5 2 10 6.5 10ZM6.5 8.25C8.29493 8.25 9.75 6.79493 9.75 5C9.75 3.20507 8.29493 1.75 6.5 1.75C4.70507 1.75 3.25 3.20507 3.25 5C3.25 6.79493 4.70507 8.25 6.5 8.25Z");
    svg.appendChild(p1);
    const c = document.createElementNS("http://www.w3.org/2000/svg", "circle");
    c.setAttribute("cx", "6.5");
    c.setAttribute("cy", "5");
    c.setAttribute("r", "1.75");
    svg.appendChild(c);
    return svg;
  }

  static graph_bars(): SVGSVGElement {
    const svg = SVG.svg(16, 16, "graph-icon");
    const l = document.createElementNS("http://www.w3.org/2000/svg", "line");
    l.setAttribute("x1", "4.19995");
    l.setAttribute("x2", "4.19995");
    l.setAttribute("y1", "13.5");
    l.setAttribute("y2", "9.83333");
    svg.appendChild(l);
    const l2 = document.createElementNS("http://www.w3.org/2000/svg", "line");
    l2.setAttribute("x1", "6.75952");
    l2.setAttribute("x2", "6.75952");
    l2.setAttribute("y1", "13.5");
    l2.setAttribute("y2", "6.16667");
    svg.appendChild(l2);
    const l3 = document.createElementNS("http://www.w3.org/2000/svg", "line");
    l3.setAttribute("x1", "9.31982");
    l3.setAttribute("x2", "9.31982");
    l3.setAttribute("y1", "13.5");
    l3.setAttribute("y2", "7.63333");
    svg.appendChild(l3);
    const l4 = document.createElementNS("http://www.w3.org/2000/svg", "line");
    l4.setAttribute("x1", "11.8794");
    l4.setAttribute("x2", "11.8794");
    l4.setAttribute("y1", "13.5");
    l4.setAttribute("y2", "2.5");
    svg.appendChild(l4);
    return svg;
  }

  static graph_lines(): SVGSVGElement {
    const svg = SVG.svg(16, 16, "graph-icon");
    const l = document.createElementNS("http://www.w3.org/2000/svg", "line");
    l.setAttribute("x1", "3");
    l.setAttribute("x2", "13");
    l.setAttribute("y1", "12.5");
    l.setAttribute("y2", "12.5");
    svg.appendChild(l);
    const p = document.createElementNS("http://www.w3.org/2000/svg", "path");
    p.setAttribute("d", "M3 10.0345L5.66963 6.73563L9.34038 9.02299L13.3448 4");
    svg.appendChild(p);
    return svg;
  }

  static graph_number(): SVGSVGElement {
    const svg = SVG.svg(16, 16, "graph-icon-fill");
    const p1 = document.createElementNS("http://www.w3.org/2000/svg", "path");
    p1.setAttribute("d", "M3.45872 4.32746H2.38983L0.575195 5.51354V6.56468L2.31525 5.42831H2.35787V11.6002H3.45872V4.32746Z");
    svg.appendChild(p1);
    const p2 = document.createElementNS("http://www.w3.org/2000/svg", "path");
    p2.setAttribute("d", "M4.82605 11.6002H9.61298V10.6591H6.33883V10.6059L7.78414 9.09308C9.11582 7.7472 9.49579 7.10445 9.49579 6.29124C9.49579 5.12291 8.54409 4.22803 7.17335 4.22803C5.81326 4.22803 4.81895 5.10871 4.81895 6.43683H5.86653C5.86298 5.65558 6.36724 5.14422 7.15204 5.14422C7.89068 5.14422 8.45176 5.59877 8.45176 6.3232C8.45176 6.96595 8.06824 7.4276 7.28699 8.25502L4.82605 10.8047V11.6002Z");
    svg.appendChild(p2);
    const p3 = document.createElementNS("http://www.w3.org/2000/svg", "path");
    p3.setAttribute("d", "M12.8908 11.6996C14.3752 11.6996 15.4654 10.8118 15.4618 9.60445C15.4654 8.6847 14.9079 8.02419 13.942 7.87504V7.81823C14.7019 7.62291 15.1955 7.02632 15.192 6.20956C15.1955 5.14067 14.3184 4.22803 12.9192 4.22803C11.584 4.22803 10.5116 5.03414 10.476 6.21666H11.5378C11.5627 5.54905 12.1912 5.14422 12.905 5.14422C13.6472 5.14422 14.1337 5.59521 14.1302 6.26638C14.1337 6.9695 13.5691 7.43115 12.763 7.43115H12.1486V8.32604H12.763C13.7715 8.32604 14.3539 8.8374 14.3539 9.56894C14.3539 10.2756 13.7395 10.755 12.8837 10.755C12.0954 10.755 11.481 10.3502 11.4384 9.70388H10.3233C10.3695 10.89 11.4207 11.6996 12.8908 11.6996Z");
    svg.appendChild(p3);
    return svg;
  }

  static graph_icon(type: string): SVGSVGElement {
    switch (type) {
      case "lines":
        return VizSVG.graph_lines();

      case "number":
        return VizSVG.graph_number();

      default:
        return VizSVG.graph_bars();
    }
  }

  static line_style_icon(): SVGSVGElement {
    const svg = SVG.svg(20, 20, "graph-icon");
    svg.appendChild(SVG.path("M5 14.0345L8.66963 9.73563L12.3404 12.023L16.3448 7"));
    return svg;
  }

  static step_style_icon(): SVGSVGElement {
    const svg = SVG.svg(20, 20, "graph-icon");
    svg.appendChild(SVG.path("M17.5 7H14V12.5H10V9H6V14.5H2"));
    return svg;
  }

}